module.exports = __webpack_public_path__ + "img/redcross.b225b69.png";